import { render, staticRenderFns } from "./unitList.vue?vue&type=template&id=53a79c35&scoped=true&"
import script from "./unitList.vue?vue&type=script&lang=js&"
export * from "./unitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a79c35",
  null
  
)

export default component.exports